/* eslint-disable no-new */
/* global YT */
import $ from 'jquery';

const videos = () => {
  const onPlayerReady = (event, player) => {
    const parent = $(`#${player}`).parent();
    const placeholder = parent.find('.c-video__placeholder');
    if (placeholder && placeholder.length) {
      placeholder.click(() => {
        placeholder.addClass('fade-out');
        event.target.playVideo();
        setTimeout(() => {
          placeholder.addClass('hide');
          parent.addClass('playing');
        }, 350);
      });
    }
  };

  window.onYouTubeIframeAPIReady = () => {
    const players = $('.c-video__iframe');
    if (players && players.length) {
      players.each((i, player) => {
        new YT.Player(player.id, {
          videoId: player.id.split('-')[1],
          events: {
            onReady: event => onPlayerReady(event, player.id),
          },
        });
      });
    }
  };
};
export default videos;



// WEBPACK FOOTER //
// ./src/scripts/modules/videos.js